import { render, staticRenderFns } from "./ProductTagsList.vue?vue&type=template&id=76604700&scoped=true&"
import script from "./ProductTagsList.vue?vue&type=script&lang=js&"
export * from "./ProductTagsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76604700",
  null
  
)

export default component.exports